var partials_pull  = [];    

function loading_partial(){
    if($.isEmptyObject(partials_pull)){
        $('body').removeClass('partials-loading');
    }else if(!$.isEmptyObject(partials_pull) ){
        $('body').addClass('partials-loading')
    }
}

    
function append_partial( container , cb){

    if(container.length == 0){
        return false;
    }

    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    

    $('body').addClass('loading');
    container.css('opacity',0.5);
    container.css('pointer-events','none');
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="parial-loader">Loading...</div>');

    if (container.attr('id') == "products-list-filter") {
        container.append(products_loading_template);
    }
    if (container.attr('data-partial') == "products.aggregates") {
        container.append(products_filter_loading_template);
    }



    if(data){
        data.current_url = window.location.pathname;
    }
    if(container.data('xhr')){
        container.data('xhr').abort();
    }

    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }

   $.ajax({
        url     : ext_domain + '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {
            var newContent = $(data).html();
            var t = container.append(newContent);
            
           container.css('pointer-events','auto');
            

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();

            container.animate({'opacity':1},500);
            container.css('pointer-events','auto');
            container.css('min-height','auto');



            $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }

            loading_partial();
        },
        error: function (response) {
            loading_partial();
        }
    });

    loading_partial();
    
}
function load_partial( container , cb){

    if(container.length == 0){
        return false;
    }

    var unique_partial_id = Math.floor(Math.random()* 1000000),
        d = container.data(),
        data = {};

    for(var i in d){
        if(i!='partial'){
            data[i] = d[i];
        }
    }
    

    $('body').addClass('loading');
    container.css('opacity',0.5);
    container.css('pointer-events','none');
    container.css('min-height',container.height());
    container.addClass('loading');
    container.append('<div class="parial-loader">Loading...</div>');

    if (container.attr('id') == "products-list-filter") {
        container.append(products_loading_template);
    }
    if (container.attr('data-partial') == "products.aggregates") {
        container.append(products_filter_loading_template);
    }



    if(data){
        data.current_url = window.location.pathname;
    }
    if(container.data('xhr')){
        container.data('xhr').abort();
    }

    var ext_domain = '';
    if (container.data('ext_domain')) {
        ext_domain = container.data('ext_domain');
    }

   $.ajax({
        url     : ext_domain + '/partial/' + d.partial,
        data    : data,
        method  : 'GET',

        success: function (data) {
            var newContent = $(data.markup);
            var t = container.replaceWith(newContent);
            
           container.css('pointer-events','auto');
            if(newContent.text().length == 0){
                container.hide();
            }else{
                container.show();
            } 

            container.removeClass('loading');
            $('body').removeClass('loading');
            container.find('.parial-loader').remove();
           $('#' + newContent.attr('id')).removeClass('loading');

            container.css('min-height','0');

            if(typeof(cb) !== 'undefined'){
                cb(newContent);
            }

            loading_partial();
            initForm(container);
        },
        error: function (response) {
            loading_partial();
        }
    });

    loading_partial();
    
}